import apiClient from "./apiClient";
import { UpdateAccountSettingsRequest } from "../models/RequestModels/UpdateAccountSettingsRequest";
import { AccountResponse } from "../models/ResponseModels/AccountResponse";

export const updateAccountSettingsRequest = async (
  body: UpdateAccountSettingsRequest,
): Promise<{ account: AccountResponse }> => {
  const response = await apiClient.patch<{ account: AccountResponse }>(
    "/account/settings",
    body,
  );

  return response.data;
};

export const requestAccountDeletionRequest = async (): Promise<{
  message: string;
  account: AccountResponse;
}> => {
  const response = await apiClient.post<{
    message: string;
    account: AccountResponse;
  }>("/account/deletion-request");

  return response.data;
};

export const cancelAccountDeletionRequest = async (): Promise<{
  message: string;
  account: AccountResponse;
}> => {
  const response = await apiClient.delete<{
    message: string;
    account: AccountResponse;
  }>("/account/deletion-request");

  return response.data;
};
